import React, { useEffect, useState } from "react";
import { TokenTransferStepProps } from "../../TokenTransferStep";
import TransferPending from "./TransferPending";
import TransferConfirmed from "./TransferConfirmed";
import TransferFailed from "./TransferFailed";
import { useFormContext } from "react-hook-form";
import { TokenTransferStatus } from "../../../hooks/types";
import usePollTokenTransferStatus from "../../../hooks/usePollTokenTransferStatus";
import { TokenTransferToken } from "../../../..";

export default function Transferring({
  onError,
  onSuccess,
  token,
  ...props
}: TokenTransferStepProps) {
  const { formState } = useFormContext();

  const isPollingEnabled = !!props.isShowing && !!props.transactionId;

  const {
    data,
    hasError,
    setEnabled: setPollingEnabled,
  } = usePollTokenTransferStatus(props.transactionId ?? "", isPollingEnabled);

  useEffect(() => {
    if (isPollingEnabled) setPollingEnabled(true);
  }, [isPollingEnabled, setPollingEnabled]);

  const [savedTokenData, setSavedTokenData] = useState<TokenTransferToken>();

  useEffect(() => {
    // storing the token data on the client
    // because userNFT token data is missing after successful transfer
    if (token && !savedTokenData) {
      setSavedTokenData(token);
    }
  }, [token, setSavedTokenData, savedTokenData]);

  const isFailedFormSubmission = !!formState.errors.root;

  const isFailedTransferStatus =
    data?.status === TokenTransferStatus.Failed || hasError;

  const isCompletedTransferStatus =
    data?.status === TokenTransferStatus.Completed;

  useEffect(() => {
    if (props.isShowing && isCompletedTransferStatus) {
      onSuccess && onSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompletedTransferStatus, props.isShowing]);

  useEffect(() => {
    if (props.isShowing && (isFailedFormSubmission || isFailedTransferStatus))
      return onError && onError();
  }, [
    isFailedFormSubmission,
    isFailedTransferStatus,
    onError,
    props.isShowing,
  ]);

  if (isFailedFormSubmission || isFailedTransferStatus)
    return <TransferFailed {...props} />;

  if (isCompletedTransferStatus)
    return <TransferConfirmed {...props} token={savedTokenData} />;

  return <TransferPending {...props} />;
}
